// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"208":"35936535","374":"a7cf93b2","438":"f6e391ac","453":"efb00a8b","466":"37873051","507":"be598ac7","801":"0ebf8aa6","961":"6520fbea"}[chunkId] + ".chunk.js";
};